import axios, { Canceler } from 'axios';
import { getUrlPartNumberApi } from '../utils/util';
import ApiHandler from './ApiHandler';

const cancelToken = axios.CancelToken;
let cancel: Canceler;


export const baseURL = String(getUrlPartNumberApi(window));

const tokenPartNumber = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiJBdmlzb0VtYmFycXVlIiwidW5pcXVlX25hbWUiOiJBdmlzb0VtYmFycXVlIiwibmFtZWlkIjoiQXZpc28gZGUgRW1iYXJxdWUiLCJlbWFpbCI6IiIsInJvbGUiOiJbXSIsImVudGl0aWVzIjoibnVsbCIsInVzZXJWaWV3cyI6IltdIiwidXNlck1lbnUiOiJbXSIsIm5iZiI6MTYzNTM1NjQyNywiZXhwIjoxOTUwODg5MjI3LCJpYXQiOjE2MzUzNTY0MjcsImlzcyI6Imh0dHBzOi8vbG9jYWxob3N0OjQ0MzAzIn0.Dc-0EjiS_tC0Cv3wTWU1RW6F3YRjEKeMIhIk_Y9YNp4"

export default class PartNumberApi {
    
    static async search(companyBomCode: string, value: any) {
        if (cancel !== undefined){
            cancel('cancelled-by-request');
        }

        var parameters = `companyBomCode=${companyBomCode}&Description=${value}&OnlyActive=true`;

        var response = await ApiHandler(baseURL, tokenPartNumber)
            .get(`/PartNumber/search?${parameters}`, {
                cancelToken: new cancelToken(c => {
                    cancel = c;
                })
            });
        return response.data;
    }
}
